import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';

const EditTrials = ({ selectedTrialId, onChangeSelection }) => {

    const trialList = useSelector((state) => state.trails_name.data);

    const [search, setSearch] = useState('');
    const [filterTrialList, setFilterTrialList] = useState(trialList);

    useEffect(() => {
        if (trialList && !selectedTrialId) {
            onChangeSelection(trialList[0].trialID)
        }
    }, [selectedTrialId, trialList]);

    useEffect(() => {
        if (search && search.length > 0) {
            let filteredRecords = trialList.filter(item => item.trialName.toLowerCase().includes(search.toLowerCase()));
            setFilterTrialList(filteredRecords)
        } else {
            setFilterTrialList(trialList)
        }
    }, [search, trialList]);



    return (
        <>
            

                <div className="flex relative mb-[25px] pl-[25px]">
                    <svg className="absolute  top-[12px] left-[35px]" width="20" height="20" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M11.1792 10.3608C10.984 10.1655 10.6674 10.1655 10.4721 10.3608C10.2769 10.556 10.2769 10.8726 10.4721 11.0679L11.1792 10.3608ZM12.7578 13.3536C12.953 13.5488 13.2696 13.5488 13.4649 13.3536C13.6601 13.1583 13.6601 12.8417 13.4649 12.6464L12.7578 13.3536ZM5.31401 3.2433C5.58675 3.2001 5.77283 2.94398 5.72963 2.67124C5.68644 2.3985 5.43031 2.21241 5.15757 2.25561L5.31401 3.2433ZM2.36693 5.04625C2.32373 5.31899 2.50981 5.57511 2.78256 5.61831C3.0553 5.66151 3.31142 5.47542 3.35462 5.20268L2.36693 5.04625ZM10.4721 11.0679L12.7578 13.3536L13.4649 12.6464L11.1792 10.3608L10.4721 11.0679ZM6.2542 10.7857C3.69001 10.7857 1.61133 8.70702 1.61133 6.14285H0.611328C0.611328 9.25931 3.13773 11.7857 6.2542 11.7857V10.7857ZM10.8971 6.14285C10.8971 8.70702 8.81838 10.7857 6.2542 10.7857V11.7857C9.37066 11.7857 11.8971 9.25931 11.8971 6.14285H10.8971ZM6.2542 1.5C8.81838 1.5 10.8971 3.57868 10.8971 6.14285H11.8971C11.8971 3.02639 9.37066 0.5 6.2542 0.5V1.5ZM6.2542 0.5C3.13773 0.5 0.611328 3.02639 0.611328 6.14285H1.61133C1.61133 3.57868 3.69001 1.5 6.2542 1.5V0.5ZM5.15757 2.25561C3.72107 2.48313 2.59445 3.60975 2.36693 5.04625L3.35462 5.20268C3.51436 4.19408 4.3054 3.40305 5.31401 3.2433L5.15757 2.25561Z" fill="#1B2A3D" />
                    </svg>
                    <input
                        type="text"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        placeholder="Search by trial name"
                        className="border text-base rounded-lg block w-full p-2.5 h-12 border-[#C8D6E6]  pl-[35px]"
                    />
                </div>
              
                    <div className="trials-list flex flex-col cursor-pointer h-[calc(100vh-220px)] overflow-y-auto ">
                        {filterTrialList && filterTrialList.map((val, index) => {
                            if (val.trialID === selectedTrialId) {
                                return (<div className="p-3 pl-[25px] font-medium active border border-[#C8D6E6] rounded-lg" style={{ color: '#245CEA', background: '#fff' }}>{val.trialName}</div>);
                            } else {
                                return (<div onClick={() => onChangeSelection(val.trialID)} className="p-3 pl-[25px] font-medium">{val.trialName}</div>);
                            }
                        })}

                        
                    </div>
                
            
        </>
    )
}

export default EditTrials;